import VisualMatchingDetailView from "@features/tools/view/visual-matching-view/visual-matching-detail-view";

const VisualMatchingDetail = () => {
  return <VisualMatchingDetailView />;
};

export default VisualMatchingDetail;
